export default {
  accommodations: [],
  pagination: {},
  accommodation: {}
}
